/* tslint:disable */
/* eslint-disable */
/**
 * profile-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PermissionRecordType = {
    City: 'city',
    Country: 'country',
    SessionType: 'session_type'
} as const;

export type PermissionRecordType = typeof PermissionRecordType[keyof typeof PermissionRecordType];



